import Popup from 'reactjs-popup'
import Button from '../../../../Button'
import SubjectCreateButton from '../../GridsSidebar/SubjectCreateButton'
import Modal from 'components/Modal'

const GridsListModal = ({
  handleCloseGridsModal,
  gridsSidebarOpened,
  handleNewSubjectWindow,
  answer,
  isCreateSubject,
  isSkippingSubject,
  gridsFromSubject,
  content,
  onSuccessCreateSubject,
  beginTimestamp = null,
  endTimestamp = null,
}) => {
  return (
    <Modal isOpen={gridsSidebarOpened} closeModal={handleCloseGridsModal}>
      <div className="pr-[30px]">
        {isCreateSubject && gridsFromSubject?.length === 0 ? (
          <div className="text-over-secondary-background text-md h-52 flex justify-center items-center">
            Nicio grilă adaugată
          </div>
        ) : (
          content
        )}
        <div className="flex gap-[15px] pb-[15px]">
          {isCreateSubject && gridsFromSubject?.length > 0 ? (
            <SubjectCreateButton
              onSuccess={onSuccessCreateSubject}
              subject={gridsFromSubject}
            />
          ) : answer === null ? (
            <Button
              isLoading={isSkippingSubject}
              className="bg-btn-primary w-[150px] flex  h-8"
              onClick={() => handleNewSubjectWindow('skip')}
            >
              {beginTimestamp === null ? 'Altă simulare' : 'Renunță'}
            </Button>
          ) : null}
        </div>
      </div>
    </Modal>
  )
}

export default GridsListModal
